import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";

export default function EternalLife() {
  return (
    <>
      <PageHero
        eyebrow="Cornerstone teaching"
        title="What is eternal life?"
        subtitle='"And this is eternal life, that they know You, the only true God, and Jesus Christ whom You have sent." — John 17:3'
      />
      <section className="py-16 sm:py-24">
        <div className="container-reading prose-editorial">
          <p className="lead">
            Eternal life, as Jesus described it, is not merely never-ending time. It is a real relationship with the
            living God — a life that begins the moment you trust Christ and continues, unbroken, into everlasting joy
            with Him.
          </p>

          <div className="my-10 border-l-2 border-gold bg-subtle p-6">
            <p className="eyebrow">Answer in 40 seconds</p>
            <p className="mt-3 text-ink">
              Eternal life is God's gift in Jesus Christ. It is the life of knowing God — beginning today, continuing
              forever. It cannot be earned by religious effort. It is received by grace through faith in Jesus, who
              gave Himself as a ransom for us.
            </p>
          </div>

          <h2>Why we need eternal life</h2>
          <p>
            Scripture is honest about our condition. Every person has sinned (Romans 3:23). Sin separates us from the
            God who is life. The wages of sin is death — not merely biological death, but spiritual death, cut off
            from God's life-giving presence (Romans 6:23).
          </p>

          <h2>Eternal life is God's gift</h2>
          <p>
            "For the wages of sin is death, but the free gift of God is eternal life in Christ Jesus our Lord"
            (Romans 6:23). Eternal life is not something we work for. It is something we receive.
          </p>

          <h2>Can good works save us?</h2>
          <p>
            No religious effort, moral achievement, or family heritage can secure eternal life. "For it is by grace
            you have been saved, through faith — and this is not from yourselves, it is the gift of God — not by
            works, so that no one can boast" (Ephesians 2:8–9).
          </p>

          <h2>Assurance of salvation</h2>
          <p>
            "I write these things to you who believe in the name of the Son of God, that you may know that you have
            eternal life" (1 John 5:13). God wants His children to be sure. Assurance rests on God's promise, Christ's
            finished work, and the Spirit's presence in a changing life.
          </p>

          <h2>Life after death</h2>
          <p>
            Death is not the end. Scripture teaches that every person will be bodily raised — those who trusted
            Christ to everlasting life with God, and those who rejected Him to just judgment. Christianity holds
            grief and hope together honestly.
          </p>

          <h2>Growing in eternal life</h2>
          <p>
            Eternal life is dynamic. It grows through Scripture, prayer, obedience, community, and time. If you have
            trusted Christ today, you have already begun.
          </p>

          <div className="my-10 border border-terracotta/40 bg-terracotta/5 p-6 rounded-none">
            <p className="eyebrow text-terracotta-dark">What this does not mean</p>
            <ul className="mt-3 space-y-2 text-ink">
              <li>Eternal life is not automatic for every person regardless of response.</li>
              <li>It is not achieved by religious ritual, family heritage, or moral striving.</li>
              <li>It is not merely "going to heaven when you die" — it starts today, in relationship with God.</li>
            </ul>
          </div>

          <h2>What next?</h2>
          <p>
            Read the Gospel of John slowly. Talk honestly to God. Consider your response to Jesus Christ. If you would
            like to speak with an elder, please reach out.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/articles/what-is-eternal-life" className="btn-primary">Read the full article</Link>
            <Link to="/contact#ask" className="btn-ghost">Ask a Question</Link>
            <Link to="/the-gospel" className="btn-ghost">Understand the Gospel</Link>
          </div>
        </div>
      </section>
    </>
  );
}
